import type {
  FocusEventHandler,
  ChangeEventHandler,
  KeyboardEventHandler,
  Ref,
} from "react"
import {
  useContext,
  createContext,
} from "react"
import type { ValidationElement } from "./ValidationElement"

export interface ValidationContextValue {
  validityState: ValidityState;
  showValidationMessage: boolean;
  validationElementProps: {
    refCallback: (element: ValidationElement | null) => void;
    onBlur: FocusEventHandler<ValidationElement>;
    onChange: ChangeEventHandler<ValidationElement>;
    onControlChange: () => void;
    onKeyDown: KeyboardEventHandler<ValidationElement>;
    ref: Ref<ValidationElement>;
  };
}

type ContextType = ValidationContextValue | null
export const ValidationContext = createContext<ContextType>(null)

export function useValidationContext(): ContextType {
  return useContext(ValidationContext)
}
